import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";
import List from "@material-ui/core/List";

import SettingsSection from "../settings-screen/settings-section";
import Stat from "./stat";
import {getTranslation} from "../../helpers/get-translation";


const styles = theme => ({
	root: {
		flexGrow: 1,
		overflowY: "auto",
		overflowX: "hidden",
		overflowScrolling: "touch",
		WebkitOverflowScrolling: "touch",
		overscrollBehavior: "none",
	},
	statsList: {
		padding: 0,
	},
});

function SettingsScreen(props) {
	const { classes, getLogos, getLevels, getHints, getOther } = props;
	return (
		<div className={classes.root}>
			<List className={classes.statsList} component="ul">

				<SettingsSection name={getTranslation("statistics_header_logos")}>
					{getLogos()
						.map((props, index) => (
							<Stat key={`stat-logos-${index}`} {...props} />
						))}
				</SettingsSection>

				<SettingsSection name={getTranslation("statistics_header_levels")}>
					{getLevels()
						.map((props, index) => {
							return <Stat key={`stat-levels-${index}`} {...props} />
						})}
				</SettingsSection>

				<SettingsSection name={getTranslation("statistics_header_hints")}>
					{getHints()
						.map((props, index) => {
							return <Stat key={`stat-hints-${index}`} {...props} />
						})}
				</SettingsSection>

				<SettingsSection name={getTranslation("statistics_header_other")}>
					{getOther()
						.map((props, index) => {
							return <Stat key={`stat-other-${index}`} {...props} />
						})}
				</SettingsSection>

			</List>
		</div>
	);
}

SettingsScreen.propTypes = {
	classes: PropTypes.shape({
		root:PropTypes.string.isRequired,
		statsList:PropTypes.string.isRequired,
	}).isRequired,

	getLogos: PropTypes.func.isRequired,
	getLevels: PropTypes.func.isRequired,
	getHints: PropTypes.func.isRequired,
	getOther: PropTypes.func.isRequired,
};

export default withStyles(styles)(SettingsScreen);
